module.exports = __webpack_public_path__ + "img/pic02.306b7f6f.png";